import React, { useEffect, useState, useRef } from 'react';

const CounterItem = ({ endValue, label }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    const currentRef = counterRef.current;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const duration = 2000;
      const increment = endValue / (duration / 16);

      const timer = setInterval(() => {
        start += increment;
        if (start >= endValue) {
          setCount(endValue);
          clearInterval(timer);
        } else {
          setCount(Math.ceil(start));
        }
      }, 16);

      return () => clearInterval(timer);
    }
  }, [isVisible, endValue]);

  return (
    <div ref={counterRef}>
      <div className="portfolio-counter-num">
        <div className="number">{count}+</div>
        <div className="text" dangerouslySetInnerHTML={{ __html: label }}></div>
      </div>
    </div>
  );
};

const Counter = () => {
  const counters = [
    { value: 8, label: 'Years of<br>Experience' },
    { value: 150, label: 'Projects<br>Completed' },
    { value: 130, label: 'Happy<br>Clients' },
    { value: 15, label: 'Awards<br>Won' }
  ];

  return (
    <section className="portfolio-counter border-bottom">
      <div className="portfolio-banner-counter">
        {counters.map((counter, index) => (
          <CounterItem 
            key={index} 
            endValue={counter.value} 
            label={counter.label} 
          />
        ))}
      </div>
    </section>
  );
};

export default Counter;